import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentService } from '@patient-ui/shared-ui/utils';

export interface AlgoliaRequest {
  query: string;
  hitsPerPage?: number;
}

export interface AlgoliaHit {
  zip_code?: string;
  city?: string;
  state_abbreviation?: string;
  locale_names?: string[];
  administrative?: string[];
  name?: string;
  objectID?: string;
  _geoloc?: {
    lat: number;
    lng: number;
  };
  latitude?: number;
  longitude?: number;
}

export interface AlgoliaResponse {
  results: Array<{
    hits: AlgoliaHit[];
    nbHits: number;
    page: number;
    nbPages: number;
    hitsPerPage: number;
  }>;
}

const HITS_PER_PAGE = 4;

@Injectable({
  providedIn: 'root',
})
export class AlgoliaApiService {
  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {}

  searchZip(requestObj: AlgoliaRequest): Observable<AlgoliaResponse> {
    const algoliaConfig = this.environmentService.algolia;

    if (!algoliaConfig) {
      throw new Error('Algolia configuration not found in environment');
    }

    const paramsObj = new URLSearchParams();
    paramsObj.set('query', requestObj.query);
    paramsObj.set(
      'hitsPerPage',
      String(requestObj.hitsPerPage || HITS_PER_PAGE)
    );
    const params = paramsObj.toString();

    const body = {
      requests: [
        { indexName: algoliaConfig.zipIndex, params },
        { indexName: algoliaConfig.placesIndex, params },
      ],
      strategy: 'stopIfEnoughMatches',
    };

    // Build URL with Algolia credentials as query parameters (not headers)
    // This avoids CORS issues
    const zipQuery = new URL(algoliaConfig.searchIndexesUrl);
    zipQuery.searchParams.set('x-algolia-api-key', algoliaConfig.apiKey);
    zipQuery.searchParams.set(
      'x-algolia-application-id',
      algoliaConfig.applicationId
    );

    return this.http.post<AlgoliaResponse>(zipQuery.toString(), body);
  }
}
